import {getColor} from "@/styles/ThemeConfig";
import {breakpoints} from "@/styles/sizes";
import Image from 'next/image';
import Slider from "react-slick";
import {useEffect, useState} from "react";
import styled from "styled-components";

import IC_LEFT_GOLD from '/public/images/ic_left_gold.svg';
import IC_RIGHT_GOLD from '/public/images/ic_right_gold.svg';
import {useRouter} from "next/router";
import {PhotoSlider} from "@/components/city/PhotoSlider";
import {DangerousDescriptionWrapper} from "@/styles/GlobalStyles";



export default function StaticPageImagesSection({description,images})
{
    return <div className={'container'}>
        {
            (images && images?.length > 0) && <div>
                <div style={{
                    maxWidth: '100%',
                    width: '100%',
                    overflow: 'hidden',
                    position: 'relative'
                }}>
                    <PhotoCarousel photos={images}/>
                </div>
            </div>
        }

        <div style={{marginTop:'50px', marginBottom:'50px'}}>
            <DangerousDescriptionWrapper
                dangerouslySetInnerHTML={{__html: description}}
            />
        </div>

    </div>
}



const NavigationLeftWrapper = styled.div`
    z-index: 10;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left:0;

    
`;

const NavigationRightWrapper = styled.div`
    z-index: 10;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right:0;

`;

const SlideItem = styled.div`
  overflow: hidden;
  cursor: pointer;
  width: 360px; /* desktop/tablet default width for variableWidth */
  margin-right: 16px;

  // @media only screen and (${breakpoints.mobile}) {
  //   width: 82vw; /* show a peek of the next item on mobile */
  //   margin-right: 14px; /* gap so the next slide is partially visible */
  // }
`;

const NavigationButton = styled.div`
    text-shadow: 1px -1px 6px rgba(0, 0, 0, 0.38);
    color: white;
    font-size: 24px;
    cursor: pointer;
    transform: ${(props) => (props.flip ? 'scaleX(-1)' : 'none')};
`;

const Wrapper  = styled.div`
    position:relative; 
    padding-left:30px; 
    padding-right:40px;
    // @media only screen and (${breakpoints.mobile}) {
    //     padding: 0;
    // }
`;

function PhotoCarousel({ photos }) {
    let slider;
    const router = useRouter();
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleOpen = (index) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };

    const [sliderKey, setSliderKey] = useState(0);

    useEffect(() => {
        const handleRouteChange = () => {
            setCurrentIndex(0);
            setSliderKey(prev => prev + 1); // force slider remount
        };

        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);


    const settings = {
      initialSlide: currentIndex,
      slidesToShow: 3,         // show 3 at a time
      slidesToScroll: 1,
      afterChange: (current) => setCurrentIndex(current),
      arrows: false,
      infinite: true,
      speed: 500,
        swipeToSlide: true,
        variableWidth: true,
      adaptiveHeight: false,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 640, settings: { slidesToShow: 1 } },
      ],
    };

    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = () => {
        setIsDragging(false); // Reset dragging state on mouse down
    };

    const handleMouseMove = () => {
        setIsDragging(true); // If mouse moves, set dragging to true
    };

    const handleMouseUp = (index) => {
        if (!isDragging) {
            handleOpen(index); // Only fire if not dragging
        }
    };



    return (
        <Wrapper>
            <NavigationLeftWrapper>
                <NavigationButton onClick={() => slider.slickPrev()}>
                    <Image src={IC_LEFT_GOLD} alt={'<'} style={{width:'40px', height:'40px', objectFit:'contain'}} />
                </NavigationButton>
            </NavigationLeftWrapper>

            <NavigationRightWrapper>
                <NavigationButton onClick={() => slider.slickNext()}>
                    <Image src={IC_RIGHT_GOLD} alt={'>'} style={{width:'40px', height:'40px', objectFit:'contain'}} />
                </NavigationButton>
            </NavigationRightWrapper>

            <Slider key={sliderKey} ref={(c) => (slider = c)} {...settings} style={{padding:0, margin:0}}>
                {photos.map((photo, index) => (
                      <SlideItem
                          key={index}
                          onMouseDown={handleMouseDown}
                          onMouseMove={handleMouseMove}
                          onMouseUp={() => handleMouseUp(index)}
                      >
                        <Image
                          src={photo.url}
                          alt={photo.alt ?? photo.name}
                          width={600}
                          height={400}
                          style={{
                            width: '100%',
                            height: 220,
                            objectFit: 'cover',
                          }}
                        />
                    </SlideItem>
                ))}
            </Slider>



            <PhotoSlider
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                photos={photos}
            />
        </Wrapper>
    );
}
